import { createFileRoute } from '@tanstack/react-router';
import { Container, Typography, Paper, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from '@tanstack/react-router';
import StructuredAuditList from '@/components/structured-audits/StructuredAuditList';

export const Route = createFileRoute('/preparer/tax-binders/$binderId/audit-logs')({
  component: TaxBinderAuditLogsPage,
});

function TaxBinderAuditLogsPage() {
  const { binderId } = Route.useParams();

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link component={RouterLink} to="/preparer" color="inherit">
          Preparer Dashboard
        </Link>
        <Link component={RouterLink} to={`/preparer/tax-binders/${binderId}`} color="inherit">
          Tax Binder Details
        </Link>
        <Typography color="text.primary">Audit Logs</Typography>
      </Breadcrumbs>

      {/* Page Header */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Tax Binder Audit History
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Audit trail for all activities related to this tax binder including status changes, document uploads,
          assignments, and access history.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Tax Binder ID: {binderId}
        </Typography>
      </Paper>

      {/* Tax Binder-Specific Audit List */}
      <Paper sx={{ p: 2 }}>
        <StructuredAuditList
          entityFilter={{
            entityType: 'Organizer',
            entityId: binderId,
          }}
          height="calc(100vh - 300px)"
          pageSize={25}
        />
      </Paper>
    </Container>
  );
}
